module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/pdf.0999dcf6.svg";